import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const location = useLocation();
  
  const isActive = (path) => location.pathname === path;
  
 const navItems = [
  { path: '/', label: 'Home' },
  { path: '/services', label: 'Services' },
  { path: '/industries', label: 'Industries' },
  { path: '/insights', label: 'Insights' },
  { path: '/about', label: 'About' },
];


  return (
    <nav className="bg-[#0A2540] border-b border-[#2E2E2E]/20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
<Link to="/" className="flex items-center">
  <div className="bg-white/90 backdrop-blur px-2 py-1 sm:px-3 sm:py-2 rounded-md shadow-sm">
    <img
  src="/images/fulllogo_transparent_nobuffer.png"
  alt="PulseShift Realty Partners"
  className="h-12 sm:h-10 w-auto"
/>
  </div>
</Link>
          {/* Navigation Links */}
          <div className="flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? 'text-white border-b-2 border-[#4A6FA5]'
                    : 'text-gray-300 hover:text-white hover:bg-[#0A2540]/80'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/contact"
              className="ml-2 px-6 py-2 bg-[#4A6FA5] text-white text-sm font-semibold rounded hover:bg-[#3d5a85] transition-colors"
            >
              Receive a Quote
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
